module.exports = __webpack_public_path__ + "img/active-14.e79f0880.svg";